{
  "common.close": "Zavřít",
  "common.athleteFallback": "sportovec {id}",
  "splash.title": "{app} — animovaná vizualizace aktivit",
  "splash.tagline": "Tvá data ze&nbsp;Stravy v pohybu",
  "splash.demo": "Demo",
  "tab.query.title": "Mapa: {name}",
  "tab.query.heading": "Dotaz na aktivity:",
  "tab.query.optDays": "poslední dny",
  "tab.query.optActivities": "poslední aktivity",
  "tab.query.optIds": "ID aktivit",
  "tab.query.optDates": "Rozsah dat",
  "tab.query.idsPlaceholder": "sem zadej ID aktivit",
  "tab.query.after": "Od:",
  "tab.query.before": "Do:",
  "tab.query.autozoom": "Po importu automaticky přiblížit <i class=\"hf hf-bullseye\"></i> na výsledky",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> Načíst",
  "tab.query.createAccount": "Vytvoř si účet a/nebo se přihlas.",
  "tab.query.sports": "Sporty:",
  "tab.query.allSports": "Všechny sporty",
  "tab.query.sportsExcept": "Všechny kromě",
  "tab.query.sportsNone": "Žádný",
  "tab.query.loadingSports": "Načítání sportů…",
  "tab.query.sportsFailed": "Sporty na této mapě se nepodařilo načíst",
  "tab.query.noSports": "Zatím žádné aktivity",
  "tab.activities.title": "Zobrazené aktivity",
  "tab.activities.clearSelection": "Zrušit výběr",
  "tab.activities.renderSelected": "Zobrazit vybrané",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> Přiblížit na výběr",
  "tab.controls.title": "Nastavení vrstvy",
  "tab.controls.timescale": "Časová škála <i>&tau;</i>",
  "tab.controls.timescaleHint": "rychlost přehrávání",
  "tab.controls.period": "Perioda <i>T</i>",
  "tab.controls.periodHint": "aktivita ~ model",
  "tab.controls.dotSize": "Velikost teček",
  "tab.controls.pathWidth": "Šířka tras",
  "tab.controls.pathWidthHint": "nula trasy skryje",
  "tab.controls.colors": "Barvy",
  "tab.controls.colorsHint": "otočit paletu",
  "tab.controls.shadows": "Stíny",
  "tab.profile.loginTitle": "Přihlásit se",
  "tab.profile.anonNote": "Po přihlášení přes Stravu uvidíš své vlastní aktivity a budeš moct spravovat svůj účet Heatflask.",
  "tab.profile.loginLink": "Přihlásit se přes Stravu",
  "tab.profile.editOnStrava": "Upravit profil na Stravě",
  "tab.profile.indexNote": "Souhrny tvých aktivit indexujeme, aby byly rychle dostupné.",
  "tab.profile.viewIndex": "Zobrazit index",
  "tab.profile.sharedMaps": "Sdílené mapy",
  "tab.profile.sharedMapsNote": "Vypnuto: své aktivity na Heatflasku vidíš jen ty. Zapnuto: každý, kdo má odkaz na tvou mapu, uvidí aktivity, které máš na Stravě veřejné. Soukromé zůstanou v každém případě jen tvoje. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">Jak funguje soukromí</a>",
  "tab.profile.logout": "Odhlásit se",
  "tab.profile.deleteAccount": "Smazat účet",
  "tab.profile.deleteConfirm": "Smazat tvůj účet Heatflask?\n\nTím se odstraní tvé indexované aktivity a Heatflask ztratí přístup k tvým datům ze Stravy. Tuto akci nelze vrátit zpět.",
  "tab.profile.languageHeading": "Jazyk",
  "tab.profile.languageAuto": "Automaticky",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">Pomoz nám opravit překlady nebo přidat nové!</a>",
  "tab.profile.unitsHeading": "Jednotky",
  "tab.profile.unitsAuto": "Automaticky",
  "tab.profile.unitsMetric": "Metrické (km, m)",
  "tab.profile.unitsImperial": "Imperiální (mi, ft)",
  "tab.profile.textSizeHeading": "Velikost textu",
  "tab.profile.textSmaller": "Menší",
  "tab.profile.textReset": "Normální",
  "tab.profile.textLarger": "Větší",
  "tab.profile.mapDefaultsHeading": "Výchozí nastavení mapy",
  "tab.profile.mapDefaultsNote": "Začínat s touto podkladovou mapou, terénem a nastavením vrstvy vždy, když otevřete mapu, jejíž odkaz nenastavuje vlastní. Sdílené odkazy stále ukazují přesně to, co vidíte.",
  "tab.profile.mapDefaultsSave": "Uložit jako moje výchozí",
  "tab.profile.mapDefaultsForget": "Zapomenout",
  "tab.info.title": "Info",
  "tab.info.controlsHeading": "Ovládání",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + tažení",
  "tab.info.shiftDragDesc": "Vyber aktivity obdélníkem. Na dotykové obrazovce nejdřív klepni na <i class=\"hf-object-group\"></i> a pak táhni jedním prstem. Naposledy vybraná aktivita zobrazí své podrobnosti a seznam aktivit se k ní posune.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + tažení",
  "tab.info.ctrlDragDesc": "Otáčej a nakláněj mapu ve 3D, nebo použij dva prsty",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "Otevřít nebo zavřít postranní panel",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "Předchozí nebo další karta panelu",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "Zavřít postranní panel",
  "tab.info.liveUrlHeading": "Živá URL",
  "tab.info.liveUrlDesc": "Pohled na mapu a nastavení animace se ukládají do URL stránky, takže každý, s kým ji sdílíš, uvidí totéž.",
  "tab.info.videoHeading": "Export videa",
  "tab.info.videoDesc": "Tlačítko <i class=\"hf-video-camera\"></i> nahraje animaci jako MP4: klepni na něj, nastav rámeček nad požadovanou část mapy a dalším klepnutím spusť nahrávání. Nahraje se jedna celá smyčka animace, takže se video plynule opakuje; smyčka delší než {max} s (nejdelší video, které Strava přijme) se po {max} s ořízne.",
  "tab.info.contributeHeading": "Zapoj se",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> Podpořit na GitHubu",
  "tab.info.contactsHeading": "Kontakt",
  "map.basemapAndTerrain": "Podkladová mapa a terén",
  "map.pauseAnimation": "Pozastavit animaci",
  "map.resumeAnimation": "Pokračovat v animaci",
  "capture.record": "Nahrát video (smyčka {period} s)",
  "capture.recordTruncated": "Nahrát video (jeden cyklus trvá {period} s; nahraje se jen prvních {max} s)",
  "capture.recordArea": "Nahrát oblast uvnitř rámečku",
  "capture.stop": "Zastavit nahrávání",
  "capture.selectionTooSmall": "výběr je příliš malý",
  "capture.saved": "uloženo: {name} ({size})",
  "capture.cancelled": "nahrávání zrušeno",
  "capture.failed": "nahrávání selhalo: {error}",
  "capture.loadingEncoder": "načítání kodéru…",
  "capture.waitingForMap": "čekání na načtení mapy…",
  "capture.encoding": "kódování… {percent} %",
  "capture.finalizing": "dokončování…",
  "share.title": "Sdílet odkaz na tuto mapu",
  "share.copied": "odkaz zkopírován",
  "share.copiedUnshared": "odkaz zkopírován – vaše mapa ale není sdílená, takže ji nikdo jiný neotevře. Zapněte „Sdílené mapy“, pokud to chcete změnit.",
  "share.unshared": "Vaše mapa není sdílená, takže tento odkaz nikdo jiný neotevře. Zapněte „Sdílené mapy“, pokud to chcete změnit.",
  "share.copyThis": "Zkopírujte tento odkaz:",
  "update.available": "Je k dispozici nová verze Heatflasku.",
  "update.reload": "Načíst znovu",
  "import.title": "Import",
  "import.stop": "Zastavit",
  "import.stopping": "zastavování…",
  "import.contacting": "spojení se Stravou…",
  "import.countOf": "{received} z {total} aktivit",
  "import.count": "Aktivity: {received}",
  "import.waitStrava": "Pozastaveno do {time} kvůli limitu stahování Stravy. Nech stránku otevřenou; obnovení to nezrychlí.",
  "import.waitRationed": "Dnešní rychlá stahování jsou vyčerpaná. Zbytek pokračuje v {time}, pomaleji. Nech stránku otevřenou.",
  "import.dailyLimit": "Denní limit stahování Stravy je vyčerpán. Zkus to znovu po {time}.",
  "import.dailyRationed": "Tvůj dnešní podíl stahování ze Stravy je vyčerpán. Zkus to znovu po {time}.",
  "import.noActivitiesYet": "Tvůj účet na Stravě zatím nemá žádné aktivity. Nahraj nebo zaznamenej nějakou na Stravě a objeví se tady.",
  "table.noActivities": "žádné aktivity",
  "table.untitled": "(bez názvu)",
  "activities.pageTitle": "{app} — Index aktivit",
  "activities.heading": "Index aktivit",
  "activities.fetching": "Načítání aktivit...",
  "activities.rateLimit": "Dosažen limit požadavků Stravy; pokračování v {time}",
  "activities.noData": "Bohužel žádná data &#128577;",
  "activities.colServerCache": "Trasa v mezipaměti serveru (Mongo)",
  "activities.colBrowserCache": "Trasa v mezipaměti tohoto prohlížeče",
  "activities.cachedServer": "Trasa {id} je v mezipaměti serveru",
  "activities.notCachedServer": "Trasa {id} není v mezipaměti serveru",
  "activities.cachedBrowser": "Trasa {id} je v mezipaměti tohoto prohlížeče",
  "activities.notCachedBrowser": "Trasa {id} není v mezipaměti tohoto prohlížeče",
  "sport.AlpineSki": "Sjezdové lyžování",
  "sport.BackcountrySki": "Skialpinismus",
  "sport.Badminton": "Badminton",
  "sport.Basketball": "Basketbal",
  "sport.Canoeing": "Kanoistika",
  "sport.Cricket": "Kriket",
  "sport.Crossfit": "Crossfit",
  "sport.Dance": "Tanec",
  "sport.EBikeRide": "Jízda na elektrokole",
  "sport.Elliptical": "Eliptický trenažér",
  "sport.EMountainBikeRide": "Jízda na elektrickém MTB",
  "sport.Golf": "Golf",
  "sport.GravelRide": "Jízda na gravelu",
  "sport.Handcycle": "Handbike",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "Turistika",
  "sport.IceSkate": "Bruslení",
  "sport.InlineSkate": "Inline bruslení",
  "sport.Kayaking": "Kajak",
  "sport.Kitesurf": "Kitesurfing",
  "sport.MountainBikeRide": "Jízda na horském kole",
  "sport.NordicSki": "Běžecké lyžování",
  "sport.Padel": "Padel",
  "sport.PhysicalTherapy": "Fyzioterapie",
  "sport.Pickleball": "Pickleball",
  "sport.Pilates": "Pilates",
  "sport.Racquetball": "Racquetball",
  "sport.Ride": "Jízda na kole",
  "sport.RockClimbing": "Lezení",
  "sport.RollerSki": "Kolečkové lyže",
  "sport.Rowing": "Veslování",
  "sport.Run": "Běh",
  "sport.Sail": "Jachting",
  "sport.Skateboard": "Skateboard",
  "sport.Snowboard": "Snowboard",
  "sport.Snowshoe": "Sněžnice",
  "sport.Soccer": "Fotbal",
  "sport.Squash": "Squash",
  "sport.StairStepper": "Stepper",
  "sport.StandUpPaddling": "Paddleboard",
  "sport.Surfing": "Surfování",
  "sport.Swim": "Plavání",
  "sport.TableTennis": "Stolní tenis",
  "sport.Tennis": "Tenis",
  "sport.TrailRun": "Trailový běh",
  "sport.Velomobile": "Velomobil",
  "sport.VirtualRide": "Virtuální jízda na kole",
  "sport.VirtualRow": "Virtuální veslování",
  "sport.VirtualRun": "Virtuální běh",
  "sport.Volleyball": "Volejbal",
  "sport.Walk": "Chůze",
  "sport.WeightTraining": "Posilování",
  "sport.Wheelchair": "Invalidní vozík",
  "sport.Windsurf": "Windsurfing",
  "sport.Workout": "Trénink",
  "sport.Yoga": "Jóga"
}
